import React, { useEffect, useState } from 'react';
import FlexChild from 'layouts/flex/FlexChild';
import VerticalFlex from 'layouts/flex/VerticalFlex';
import { mainBgColor, mainBodyHeight, mainPadd, pageCommonGap1, pageCommonPadd, pageH1FontSize, pagePaddTopH, registerGap2, pageEH3FontSize, mainPadd2, registerHeight, pageCommonPadd2 } from '../constraint/VendorConst';
import AdminMobileContentBox from './common/VendorMobileContentBox';
import HorizontalFlex from 'layouts/flex/HorizontalFlex';
import P from 'components/P';
import { requester } from "App";

import { useLocation, useNavigate } from 'react-router-dom';
import Container from 'layouts/container/Container';



function VendorMobileNoticeDetail() {
    const location = useLocation(); // useLocation으로 state 읽기
    const notice = location.state?.notice;


    // const [isMounted, setMounted] = useState(false);
    // useEffect(() => {
    //     setMounted(true);
    // }, [])
    // if (isMounted) {

    // }
    console.log("전달받은 공지 데이터:", notice);

    return (

        <Container height={registerHeight}>
            <VerticalFlex gap={pageCommonGap1} backgroundColor={mainBgColor} padding={pageCommonPadd2}>
                <FlexChild height={"initial"} padding={mainPadd}>
                    <HorizontalFlex>
                        <FlexChild width="auto">
                            {/* <img onClick={() => moveToBack()} className={styles.backIcon} src={backIcon} alt='뒤로 가기 버튼' /> */}
                        </FlexChild>
                        <FlexChild justifyContent="center">
                            {/* H1 헤더 */}
                            <P size={pageH1FontSize}>공지 등록</P>
                        </FlexChild>
                    </HorizontalFlex>
                </FlexChild>
                <FlexChild >
                    <AdminMobileContentBox flexStart>
                        <VerticalFlex >
                            <FlexChild>
                                <VerticalFlex>
                                    <FlexChild alignItems={"flex-start"}>
                                        <P size={40} weight={"bold"}>{notice.title}</P>
                                    </FlexChild>
                                    <FlexChild alignItems={"flex-start"}>
                                        <P>{notice.content}</P>
                                    </FlexChild>
                                </VerticalFlex>
                            </FlexChild>

                        </VerticalFlex>
                    </AdminMobileContentBox>
                </FlexChild>
            </VerticalFlex>
        </Container>

    )

}
export default VendorMobileNoticeDetail;